import { Modal } from "antd";
import axios from "axios";
import { authHeader } from "../utils/utils";
import { UrlConstants } from "../utils/ApiConstants";
import { Notification } from "../components/notification/notification";
import { replaceWithCurrentApiVersion } from "../utils/api";

const { confirm } = Modal;

interface Row {
    [key: string]: any; // Allows any key with any value
  }

const showConfirm = (payload: Row[], endpoint: string, apiMethod: string, message: string, callBack: any = null) => {
    if (payload === undefined  || payload.length === 0) {
        alert("Please choose atleast one record.");
        return;
    }
    confirm({
        title: message,
        okText: "Yes",
        cancelText: "No",
        onOk() {
            performBulkApproveOrReject(payload, endpoint, apiMethod, callBack);
        },
        onCancel() { },
    });
};

const performBulkApproveOrReject: any = async (payload: Row[], endpoint: string,  apiMethod: string, callBack: any) => {
    if (payload.length === 0) {
        return { message: "There are no record(s) selected.", status: "SUCCESS" };
    }
    let recordIds = payload.map(p => p["id"]);
    endpoint = endpoint?.replace("{recordIds}", recordIds.join(","));
    try {
        const config = {
            method: apiMethod??"POST", // Specify the HTTP method
            url: `${UrlConstants.BASE_URL}${replaceWithCurrentApiVersion(endpoint)}`,
            data: {
              records: payload, // Request body for POST/PUT methods
            },
            headers: {
                authorization: `${authHeader().Authorization}`,
                "Access-Control-Allow-Origin": "*",
            },
          };
        await axios.request(config);
        Notification("success", "Status marked successfully.");
        if (callBack) callBack();
        return { message: "Status marked successfully. ", status: "SUCCESS" };
    } catch (err: any) {
        Notification("error", "Something went wrong, please check with admin.");
        return { message: "Something went wrong, please check with admin.", status: "ERROR" };
    }
}

export const updateOrCreateRecordsUsingBulkApi: any = (selectedRows: any[], args: any[], callBack = null, actionInfo: any) => {
    const endpoint = args[0];
    const apiMethod = args[1];
    const actionName = actionInfo.displayName??"";
    let attributes:[] = actionInfo.payloadAttrs;
    let payload: Row [] = [];

    selectedRows.map(selectedRow => {
        let row: Row = {};
        attributes.forEach((attr: any) => {  
            const key = attr["key"];
            let attrValue = attr["value"];
            const value = eval(attrValue);
            row[key] = value;
        });
        payload.push(row);
    });

    showConfirm(payload, endpoint, apiMethod, `Do you want ${actionName} ${selectedRows.length} record(s) ?`, callBack);
}